import React from "react";
import Select from '@material-ui/core/Select';
import {MenuItem} from "@material-ui/core";
import { VALID_SECONDS } from "./constants";

export interface SecondsInputProps {
  name: string;
  value?: string;
  onChange: (e: any) => void;
}

const SecondsInput = (props: SecondsInputProps) => {
  const [value, setValue] = React.useState(props.value);

  React.useEffect(() => {
    setValue(props.value);
  }, [props.value]);

  const onChange = (e: any) => {
    setValue(e.target.value)
    props.onChange(e)
  }

  return (
    <>
      <Select
        name={props.name}
        onChange={onChange}
        onSelect={onChange}
        value={value ?? ""}
        style={{width: "5em", color: "black"}}
      >
        <MenuItem value=""><em>None</em></MenuItem>
        {VALID_SECONDS.map((seconds: string) => {
          return (
            <MenuItem key={seconds} value={seconds}>{seconds}</MenuItem>
          )
        })}
      </Select>
    </>
  )
}

export default SecondsInput;
